// extracted by mini-css-extract-plugin
export default {"delimiter":"delimiter---aIBnm","job":"job---wvK3X","jobHeader":"jobHeader---a3iTX"};